import { FC } from "react"
import { AttentionsInfo } from "../../../module/attentions/containers/info"

export const AttentionsInfoPage: FC = () => <AttentionsInfo />
